import { ModalBody, ModalFooter, Stack } from "@chakra-ui/react";
import { Hash } from "viem";
import { useTranslation } from "next-i18next";
import { Text } from "uikit";
import { BulkTransactionStep, StepRow } from "components/BulkTransactionStep";
import { RaffleTokenType, RaffleUnclaimedPrize } from "views/win/userGeneratedRaffles/types";
import { parseUnclaimedPrizes } from "views/win/userGeneratedRaffles/utils/unclaimedPrizes";
import {
  NFTPrizeRow,
  CurrencyPrizeRow,
} from "views/win/userGeneratedRaffles/components/ClaimWinningsModal/NFTPrizeRow";

export const ClaimView = ({
  unclaimedPrizes,
  transactionHash,
}: {
  unclaimedPrizes: RaffleUnclaimedPrize[];
  transactionHash?: Hash | null;
}) => {
  const { tokens, ethAmount, looksAmount } = parseUnclaimedPrizes(unclaimedPrizes);
  const { t } = useTranslation();
  return (
    <>
      <ModalBody maxHeight="256px" overflowY="auto" bg="ui-bg">
        <Stack spacing={4}>
          {tokens.map((tokenData) => {
            const { token } = tokenData;
            return (
              <NFTPrizeRow
                key={`${token.collection.address}-${token.tokenId.toString()}`}
                image={token.image}
                name={token.name}
                collectionName={token.collection.name}
              />
            );
          })}
          {!!ethAmount && <CurrencyPrizeRow tokenType={RaffleTokenType.ETH} amount={ethAmount} />}
          {!!looksAmount && <CurrencyPrizeRow tokenType={RaffleTokenType.ERC20} amount={looksAmount} />}
        </Stack>
      </ModalBody>
      <ModalFooter>
        <BulkTransactionStep status="current" title="Claim Winnings" width="100%">
          <Stack spacing={4}>
            <Text textStyle="helper" bold color="text-01">
              {t("Waiting for you to confirm in wallet {{counterDisplay}}", { counterDisplay: "(1/1)" })}
            </Text>
            {transactionHash && <StepRow status="pending" text="Transaction" transactionHash={transactionHash} />}
          </Stack>
        </BulkTransactionStep>
      </ModalFooter>
    </>
  );
};
